var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1104 168h-1008c-39.766 0-72 32.234-72 72s32.234 72 72 72h1008c39.766 0 72-32.234 72-72s-32.234-72-72-72z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1104 528h-1008c-39.766 0-72 32.234-72 72s32.234 72 72 72h1008c39.766 0 72-32.234 72-72s-32.234-72-72-72z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96 888h1008c39.766 0 72 32.234 72 72s-32.234 72-72 72h-1008c-39.766 0-72-32.234-72-72s32.234-72 72-72z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.65779df8568b6ce05ffc54d295d91448.svg";
export { ForwardRef as ReactComponent };